import script from "./banners.vue?vue&type=script&setup=true&lang=js"
export * from "./banners.vue?vue&type=script&setup=true&lang=js"

import "./banners.vue?vue&type=style&index=0&id=6cb02de2&lang=css"

const __exports__ = script;

export default __exports__